module.exports = __webpack_public_path__ + "img/54.aebb8662.jpg";